var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.$helper.permission.canSeeRequest(_vm.user) ? _c('RequestGrid', {
    key: _vm.key,
    on: {
      "forceUpdate": function forceUpdate($event) {
        _vm.key++;
      }
    }
  }) : _vm._e(), _vm.$helper.permission.canSeeAppointments(_vm.user) ? _c('AppointmentsGrid', {
    key: _vm.key,
    on: {
      "forceUpdate": function forceUpdate($event) {
        _vm.key++;
      }
    }
  }) : _vm._e(), _vm.$helper.permission.canSeeClientOnMain(_vm.user) ? _c('ClientGrid', {
    key: _vm.key,
    on: {
      "forceUpdate": function forceUpdate($event) {
        _vm.key++;
      }
    }
  }) : _vm._e(), _vm.$helper.permission.canSeeContractsOnMain(_vm.user) ? _c('ContractGrid', {
    key: _vm.key,
    on: {
      "forceUpdate": function forceUpdate($event) {
        _vm.key++;
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }